import { create, all } from 'mathjs'
const mathjs = create(all)
mathjs.config({ number: 'BigNumber' })
export default {
  /**
   * 解析时间为字符串
   * @param {(Object|string|number)} time
   * @param {string} cFormat
   * @returns {string | null}
   */
  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time)
      }
      if (typeof time === 'number' && time.toString().length <= 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      return value.toString().padStart(2, '0')
    })
    return timeStr
  },

  /**
   * 格式化时间
   * @param {number} time
   * @param {string} option
   * @returns {string}
   */
  formatTime(time, option) {
    if (('' + time).length === 10) {
      time = parseInt(time) * 1000
    } else {
      time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
      return '刚刚'
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
      return '1天前'
    }
    if (option) {
      return this.parseTime(time, option)
    } else {
      return (
        d.getMonth() +
        1 +
        '月' +
        d.getDate() +
        '日' +
        d.getHours() +
        '时' +
        d.getMinutes() +
        '分'
      )
    }
  },
  /**
   * 数值（秒）转时间
   * @param {number} sec
   */
  secondsToTime(sec) {
    // 兼容毫秒
    sec = ('' + sec).length >= 8 ? Math.floor(sec / 1000) : sec
    let hour = Math.floor(sec / 3600)
    let minute = Math.floor((sec - hour * 3600) / 60)
    let second = sec - hour * 3600 - minute * 60
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minute < 10) {
      minute = '0' + minute
    }
    if (second < 10) {
      second = '0' + second
    }
    // return hour + ':' + minute + ':' + second
    return hour + ':' + minute
  },
  /**
   * 深拷贝
   * @param {Object} source
   * @returns {Object}
   */
  deepClone(source) {
    if (!source && typeof source !== 'object') {
      throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach((keys) => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = this.deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  },
  /**
   * @alias 节流
   * @param {function} fn 节流被执行函数
   * @param {Number}  delay 时间单位内
   */
  throttle(fn, delay) {
    let flag = true
    let timer = null
    return function(...args) {
      const context = this
      if (!flag) return
      flag = false
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
        flag = true
      }, delay)
    }
  },
  /**
   * @alias 防抖
   * @param {function} fn 防抖被执行函数
   * @param {Number}  delay 时间单位内
   */
  debounce(fn, delay) {
    let timer = null
    return function(...args) {
      const context = this
      if (timer) clearTimeout(timer)
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, delay)
    }
  },
  /**
   * 生成唯一字符串
   * @returns {string}
   */
  uniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
  },
  /**
 * 指定长度和进制的UUID
 * @param len       长度
 * @param radix     进制 2 8 10 16
 * @returns {string}
 */
  uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = []; var i
    radix = radix || chars.length
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
      var r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16
          uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
        }
      }
    }
    return uuid.join('')
  },
  /**
   * 将cookie转为json
   */
  cookieToJson(cookie) {
    const obj = {}
    if (cookie) {
      const cookieArr = cookie.split(';')
      cookieArr.forEach((i) => {
        const arr = i.split('=')
        const key = arr[0].replace(/(^\s*)|(\s*$)/g, '')
        obj[key] = arr[1]
      })
    }
    return obj
  },
  // 保留2位小数，如：2，会在2后面补上00.即2.00
  toDecimal2: function(x) {
    const f = Math.round(x * 100) / 100
    let s = f.toString()
    let rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 2) {
      s += '0'
    }
    return s
  },
  // 保留3位小数，如：2，会在2后面补上000.即2.000
  toDecimal3: function(x) {
    const f = Math.round(x * 1000) / 1000
    let s = f.toString()
    let rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length
      s += '.'
    }
    while (s.length <= rs + 3) {
      s += '0'
    }
    return s
  },
  // 保留2位小数，如：2，还会保留2 不会补0
  toDecimal2NoZero: function(x) {
    const f = Math.round(x * 10000) / 10000
    const s = f.toString() * 10000
    return s
  },
  // 大数据计算
  mathEvaluate: function(str) {
    str = str.replace(/null/g, '0')
    return mathjs.number(mathjs.evaluate(str))
  },
  /**
   * ocr识别时间字符串转时间戮
   * type ms毫秒，s秒
   * 例：19800102转为1980-01-02的时间戮
   */
  ocrStrTotime(str, type) {
    if (str) {
      str = `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`
      const t = new Date(str).getTime()
      if (t > 0) {
        return type === 'ms' ? t : parseInt(t / 1000)
      } else {
        return null
      }
    } else {
      return null
    }
  },
  /**
   * 分转元
   * @param {number} num
   */
  fenToYuan: function(num, len = 2) {
    if (len === 3) {
      return this.toDecimal3(num / 100)
    } else {
      return this.toDecimal2(num / 100)
    }
  },
  // 货物发货量转为小数值
  parseQtyToSmall(qty, unit) {
    let qtyStr = qty || 0
    if (qty) {
      // 吨
      if (unit === 4) {
        qtyStr = this.mathEvaluate(`${qty} / 1000`)
      }
      // 立方米
      if (unit === 5) {
        qtyStr = this.mathEvaluate(`${qty} / 1000000000`)
      }
    }
    return qtyStr
  },
}



// WEBPACK FOOTER //
// ./src/utils/tools.js